import CMSPage from 'pages'

import { fetchContent } from '@/utils/contentful/fetch-content'
import { ContentfulPagesQuery } from '@/utils/contentful/gql'

const Page = CMSPage

export async function getStaticPaths(): Promise<any> {
  const data = await fetchContent(`
    {
      pagesCollection(limit: 2500) {
        items {
          slug
        }
      }
    }
  `)

  const allPaths = data?.pagesCollection.items.map((slugFromCms: any) => {
    if (slugFromCms.slug !== '/') {
      const slug = slugFromCms.slug.split('/').filter((item: string) => {
        return item
      })

      return {
        params: { slug: slug },
      }
    }
  })

  const paths = allPaths.filter(function (path: any) {
    return path != null
  })

  return {
    paths,
    fallback: false,
  }
}

export async function getStaticProps({ params }: any) {
  const slugForQuery = params.slug.join('/')

  //
  //  This catch all dynamic route can support two levels of 'slugs'
  //
  //  https://domain.com/level-one
  //  https://domain.com/level-one/level-two
  //

  const data = await fetchContent(`{
    pagesCollection(where: { slug: "/${slugForQuery}" }, limit: 1) {
      items {
        ${ContentfulPagesQuery}
      }
    }
  }`)

  return {
    props: {
      cmsData: data.pagesCollection.items[0],
    },
  }
}

export default Page
